import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { UserSliceType } from './types';

const initialState: UserSliceType = {
  features: [],
  aasAdministeredUsersUpdated: '',
  aasFeaturesUpdated: '',
  aasMigrated: '',
  account: {
    lastLoginFailure: null,
    lastVisitedAt: '',
    loginFailures: null,
    passwordResetFailures: null,
    pin: '',
    verificationFailed: null,
  },
  address: {
    city: '',
    country: '',
    state: '',
    street1: '',
    street2: null,
    zip: '',
  },
  billable: null,
  billingProvider: '',
  birthDate: '',
  brandCode: '',
  canInvite: null,
  cancelDescription: null,
  cancelOn: '',
  cancelReason: null,
  cancellationSource: null,
  cancelledAt: null,
  companyId: null,
  companyUserId: null,
  createdAt: '',
  department: null,
  emailAddress: '',
  employeeId: null,
  enrollmentType: '',
  groupCode: null,
  id: '',
  locale: '',
  migratedAt: null,
  migrationFailedAt: null,
  migrationFailureReason: null,
  migrationInitiatedAt: null,
  name: {
    first: '',
    middle: null,
    last: '',
    suffix: '',
  },
  phoneNumber: '',
  portabilityInitiatedAt: null,
  portedOn: null,
  reactivatedAt: null,
  reactivationReason: null,
  reactivationRequestedAt: null,
  reactivationSource: null,
  referrerCode: null,
  requiresAddress: null,
  serviceEndDate: null,
  ssnLastFour: null,
  status: '',
  subscriptionId: '',
  timezoneOffset: '',
  type: '',
  updatedAt: '',
  username: '',
  vendorEmployeeId: null,
  verification: {
    eidNextRetry: null,
    pidVerified: null,
    verified: null,
  },
};

const userSlice = createAppSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserSliceData(state, action: PayloadAction<UserSliceType>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setUserName(state, action: PayloadAction<UserSliceType['name']>) {
      state.name = action.payload;
    },
    setUserAddress(state, action: PayloadAction<UserSliceType['address']>) {
      state.address = action.payload;
    },
    setUserPhoneNumber(
      state,
      action: PayloadAction<UserSliceType['phoneNumber']>,
    ) {
      state.phoneNumber = action.payload;
    },
    /* `YYYY-MM-DD`. Written by the five-step personal-info step so `useDobInitialValues`
       reads it back on a revisit; the SSN collected alongside it is deliberately never
       stored anywhere on the client. */
    setUserBirthDate(state, action: PayloadAction<UserSliceType['birthDate']>) {
      state.birthDate = action.payload;
    },
    userReset() {
      return initialState;
    },
  },
});

export const {
  setUserSliceData,
  setUserName,
  setUserAddress,
  setUserPhoneNumber,
  setUserBirthDate,
  userReset,
} = userSlice.actions;
export default userSlice.reducer;
